<agpr-dialog-container
    [id]="'manageListDialog'"
    [showClose]="true"
    [heading]="'Discover.manageList.header'"
    (close)="closeDialog(null)"
    class="agpr-manageList-dialog"
    [agprLoading]="loading"
    [agprGlobalLoading]="true"
>
    <div class="agpr-manageList">
        <div class="agpr-manageList-lhp">
            <div class="agpr-manageList-filter">
                <!-- autocomplete used here for custom "Create list [listname]" option -->
                <agpr-autocomplete
                    #autocomplete
                    [id]="id + '.filterTextInput'"
                    (clear)="resetLists()"
                    labelField="name"
                    (searchStringChanged)="filterRows($event)"
                    [customOptions]="listsAutocompleteOptions"
                    [clearOnBlur]="false"
                    placeholder="Discover.manageList.filterPlaceholder"
                    [ariaLabel]="'Discover.manageList.searchLists'"
                >
                </agpr-autocomplete>
                <agpr-button
                    (click)="createNewList()"
                    [style]="buttonTypes.icon"
                    [icon]="'fa-regular fa-duotone fa-square-plus'"
                    class="agpr-manageList-newListButton"
                >
                </agpr-button>
            </div>
            <agpr-scroll-panel class="agpr-manageList-scrollpanel">
                <agpr-table
                    id="manageListTable"
                    class="agpr-manageList-table"
                    [columns]="columnDefs"
                    [sortColumn]="nameColumn"
                    [showDelete]="false"
                    [sortAscending]="true"
                    [(ngModel)]="filteredRows"
                    (itemChanged)="selectionChanged($event)"
                    (allSelectedChanged)="selectAll($event)"
                    [vsItemSize]="37"
                    [vsMinBufferPx]="500"
                    [vsMaxBufferPx]="500"
                ></agpr-table>
            </agpr-scroll-panel>
        </div>
        <div *ngIf="focusedEntity" class="agpr-manageList-rhp">
            <div class="agpr-manageList-profile">
                <div class="agpr-manageList-profile-thumbnail">
                    <img
                        class="agpr-manageList-profile-thumbnail-img"
                        [agprImageSrc]="focusedEntity.avatarUrl"
                        alt=""
                        [agprDefaultImage]="imageDefault[focusedEntity.entityType]"
                    />
                </div>

                <div class="agpr-manageList-profile-description-container">
                    <div class="agpr-manageList-profile-description">
                        <div *ngIf="focusedEntity.entityType === entityTypes.CONTACT">
                            <div
                                class="agpr-manageList-profile-description-name agpr-manageList-overflowEllipse"
                            >
                                {{focusedEntity.firstName}} {{focusedEntity.lastName}}
                            </div>
                            <div
                                *ngIf="focusedEntity.selectedEmployment"
                                class="agpr-manageList-profile-description-jobtitle agpr-manageList-overflowEllipse"
                            >
                                {{focusedEntity.selectedEmployment?.jobTitle}}
                            </div>
                            <div
                                *ngIf="focusedEntity.selectedEmployment?.outlet?.name"
                            >
                                {{focusedEntity.selectedEmployment.outlet.name}}
                            </div>
                        </div>

                        <div *ngIf="focusedEntity.entityType === entityTypes.OUTLET">
                            <div class="agpr-manageList-profile-description-name agpr-manageList-overflowEllipse">
                                {{focusedEntity?.name}}
                            </div>
                            <div
                                *ngIf="focusedEntity?.mediaTypes.length > 0"
                                class="agpr-manageList-profile-description-jobtitle"
                            >
                                <span
                                    *ngFor="let mediaType of focusedEntity?.mediaTypes; let last = last"
                                >
                                    {{ mediaType.displayString | localize }}{{ !last ? ', ' : ''}}
                                </span>
                            </div>
                            <div *ngIf="focusedEntity?.coverageFocus">
                                {{focusedEntity?.coverageFocus.displayString}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <agpr-scroll-panel class="agpr-manageList-listSummary">
                <agpr-chip-container
                    class="agpr-manageList-chipContainer"
                    [id]="id + '.listSummary'"
                    [chips]="listSummaryChips"
                    [plainMode]="true"
                    (removeChip)="removeChip($event)"
                ></agpr-chip-container>
                <agpr-message
                    *ngIf="listSummaryChips.length === 0"
                    class="agpr-manageList-listSummary-noContent"
                    [severity]="messageSeverityEnum.noContent"
                >
                    {{ 'Discover.manageList.listSummary.noContent' | localize }}
                </agpr-message>
            </agpr-scroll-panel>
            <agpr-message
                *ngIf="addedList.length || removedList.length"
                class="agpr-manageList-changeReceipt"
                [severity]="messageSeverityEnum.info"
                [id]="id + '.changeReceipt'"
            >
                <div
                    *ngIf="addedList.length > 0"
                    class="agpr-manageList-changeReceipt-title"
                >
                    {{ 'Discover.manageList.changeReceipt.add' | localize}}
                </div>
                <div
                    *ngIf="addedList.length > 0"
                    class="agpr-manageList-changeReceipt-content"
                    tooltipStyleClass="agpr-manageList-changeReceipt-info-tooltip"
                    [pTooltip]="('Discover.manageList.changeReceipt.add' | localize) + '\n' + (addedList | joinList)"
                    tooltipPosition="top"
                >
                    <span
                        *ngFor="let list of addedList; let last = last"
                    >
                        {{ list | localize }}{{ !last ? ', ' : ''}}
                    </span>
                </div>

                <div
                    *ngIf="removedList.length > 0"
                    class="agpr-manageList-changeReceipt-title"
                >
                    {{ 'Discover.manageList.changeReceipt.remove' | localize}}
                </div>
                <div
                    *ngIf="removedList.length > 0"
                    class="agpr-manageList-changeReceipt-content"
                    tooltipStyleClass="agpr-manageList-changeReceipt-info-tooltip"
                    [pTooltip]="('Discover.manageList.changeReceipt.remove' | localize) + '\n' + (removedList | joinList)"
                    tooltipPosition="top"
                >
                    <span
                        *ngFor="let list of removedList; let last = last"
                    >
                        {{ list | localize }}{{ !last ? ', ' : ''}}
                    </span>
                </div>
            </agpr-message>
        </div>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [label]="'cancel' | localize"
            [style]="buttonTypes.secondary"
            (click)="closeDialog(null)"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [style]="buttonTypes.primary"
            [label]="'Discover.manageList.updateButton' | localize"
            [disabled]="!addedList.length && !removedList.length"
            (click)="updateLists()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>

<ng-template let-row="row" let-column="column" #countInfoCell>
    <div class="agpr-manageList-table-row">
        <label
            *ngIf="row.count !== null && !row.countLoading"
            class="agpr-manageList-table-label"
        >
            {{row.count}}
        </label>
        <span>
            <span
                *ngIf="row.modifiedUser"
                role="img"
                class="fa-regular fa-circle-info agpr-manageList-infoCircle"
                [agprTooltip]="'Tags.manageDialog.tagGroupInformation' | localize : {
                    createdDate: row.createdDate,
                    createdBy: row.createdUser,
                    modifiedDate: row.modifiedDate,
                    modifiedBy: row.modifiedUser
                }"
                [initiallyFocusable]="false"
            ></span>
            <span
                *ngIf="!row.modifiedUser"
                role="img"
                class="fa-regular fa-circle-info agpr-manageList-infoCircle"
                [agprTooltip]="'Tags.manageDialog.tagGroupInformation.unmodified' | localize : {
                    createdDate: row.createdDate,
                    createdBy: row.createdUser
                }"
                [initiallyFocusable]="false"
            ></span>
        </span>
    </div>
</ng-template>
